// extracted by mini-css-extract-plugin
export default {"list":"u-PFj","icon":"xVh7l","skeleton-progress":"BDNxe"};